import { createSlice } from '@reduxjs/toolkit';
import { RootStateOrAny } from 'react-redux';

export const CUSTOMIZATION_KEY_IN_STORE = 'customization';

export const initialState = {
	isOpen: [], // for active default menu
	fontFamily: '"Roboto", sans-serif',
	borderRadius: 12,
	opened: true,
	direction: 'ltr',
};

const customizationReducer = createSlice({
	name: 'customization',
	initialState,
	reducers: {
		openMenu: (state: RootStateOrAny, { payload }: any) => {
			state.isOpen = [payload.id];
		},
		setMenuOpen: (state: RootStateOrAny, { payload }: any) => {
			state.opened = payload.opened;
		},
		updateFontFamily: (state: RootStateOrAny, { payload }: any) => {
			state.fontFamily = payload.fontFamily;
		},
		updateBorderRadius: (state: RootStateOrAny, { payload }: any) => {
			state.borderRadius = payload.borderRadius;
		},
		setDirection: (state: RootStateOrAny, { payload }: any) => {
			state.direction = payload.direction;
		},
	},
});

export const {
	openMenu,
	setMenuOpen,
	updateFontFamily,
	updateBorderRadius,
	setDirection,
} = customizationReducer.actions;

export default customizationReducer;
